// extracted by mini-css-extract-plugin
export default {"mainText":"H0czdtfyOeuChiC5SxXJ","subText":"n5nGV5OP9k_yvWiMMjw3","saveContainer":"jQmKT3BIFyURxMBsqPrz"};